import { Box, IconButton, SxProps, Theme } from '@mui/material';
import { CloseIcon } from 'assets/icons';
import React, { FC } from 'react';

interface ImageProps {
  imageUrl: string;
  onDelete?: () => void;
  alt: string;
  width: number;
  height: number;
  sx?: SxProps<Theme>;
}

const Image: FC<ImageProps> = ({
  imageUrl,
  onDelete,
  alt,
  width,
  height,
  sx,
}) => {
  return (
    <Box sx={{ ...sx }}>
      <Box
        sx={{
          position: 'relative',
          width: width,
          height: height,
          display: 'flex',
        }}
      >
        <Box
          component='img'
          src={imageUrl}
          alt={alt}
          sx={{
            width: width,
            height: height,
            objectFit: 'contain',
            border: '1px solid #bababa',
          }}
        />
        {onDelete && (
          <IconButton
            sx={{
              width: 37,
              height: 37,
              borderRadius: '2px',
              position: 'absolute',
              top: 0,
              right: 0,
              backgroundColor: '#5F5F5FB2',
              '&:hover': {
                backgroundColor: '#5F5F5FB2',
              },
            }}
            onClick={onDelete}
          >
            <CloseIcon sx={{ color: '#fff' }} />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default Image;
